export default {
  // Dialog title
  title: "Add Label",

  // Form related
  pleaseSelect: "Please select",
  pleaseInput: "Please input",
  pleaseInputContent: "Please enter content",

  // Buttons
  cancel: "Cancel",
  confirm: "Confirm",

  // Validation messages
  requiredFieldError: "Required fields marked with * must be filled",
  addLabelSuccess: "This data has been successfully labeled",
};
